import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useSignatures } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";
import { signatureModeLabel } from "../../../helpers/enum-labels";

interface IProps {
  orderId: number;
}

export const SignaturesList: React.FC<IProps> = ({ orderId }) => {
  const { data, loading } = useSignatures({ where: { orderId } });

  if (loading) return <Loading />;

  if (!data?.signatures?.results?.length) {
    return <EmptyList text="Aucune signature" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Signataire</TableCell>
          <TableCell header>Mode</TableCell>
          <TableCell header>Date</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.signatures?.results?.map((signature) => (
          <TableRow key={`signature-${signature.id}`} hover={false}>
            <TableCell>{signature.signerName}</TableCell>
            <TableCell>{signatureModeLabel(signature.mode)}</TableCell>
            <TableCell>{formatDisplayDate(signature.signedAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
